import * as yup from 'yup'

export const schema = yup.object({
    dataInicial: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    dataFinal: yup
        .mixed<string>()
        .concat(yup.date())
        .transform((curr, orig) => (orig === '' ? null : curr))
        .nullable(),
    status: yup.string(),
    titulo: yup.string()
})
